import { Injectable } from '@angular/core';
import type { NotificationMarkManyAsReadQueryInterface } from '@zaoblako/shared/modules/notification/dtos/notification-mark-many-as-read-query.dto';
import type { NotificationCountInterface } from '@zaoblako/shared/modules/notification/dtos/informer/notification.count.dto';
import type { NotificationQueryInterface } from '@zaoblako/shared/modules/notification/dtos/notification.query.dto';
import type { NotificationPageInterface } from '@zaoblako/shared/modules/notification/dtos/notification-page.dto';
import { NotificationKindEnum } from '@zaoblako/shared/modules/notification/enums/notification.kind.enum';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService extends BaseService {
  public unreadCount$: BehaviorSubject<NotificationCountInterface> = new BehaviorSubject(null);
  public eventReadNotification: Subject<NotificationKindEnum> = new Subject<NotificationKindEnum>();

  protected baseUrl = '/basis/notification';

  public markManyAsRead(params?: NotificationMarkManyAsReadQueryInterface): Observable<null> {
    return this.http.put<null>(`${this.baseUrl}/mark-as-read`, null, {
      params: params ? this.objectToHttpParams(params) : {}
    });
  }

  public markOneAsRead(id: number): Observable<null> {
    return this.http.put<null>(`${this.baseUrl}/${id}/mark-as-read`, null);
  }

  public getActivityFeed(params?: NotificationQueryInterface): Observable<NotificationPageInterface> {
    return this.http.get<NotificationPageInterface>(this.baseUrl, {
      params: params ? this.objectToHttpParams(params) : {}
    });
  }

  public getUnreadNotificationCount(): Observable<NotificationCountInterface> {
    return this.http.get<NotificationCountInterface>(`${this.baseUrl}/count`);
  }
}
